var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"!max-w-none",attrs:{"id":"features"}},_vm._l((_vm.features),function(section,index){return _c(_vm.mapping[section.type],{key:section.type + index,tag:"component",class:{ 'bg-teal': index % 2 !== 0 },attrs:{"section":section,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }